<template>
  <v-text-field
    v-model="displayMonitorRadius"
    :label="labelRadius"
    :rules="monitorRadiusRules"
  ></v-text-field>
</template>
<script>
import {
  transformRadiusToKm,
  formatDisplayMonitorRadius,
} from "@/common/basic.utilities";
const EMITTED_ACTIONS = {
  UPDATE_RADIUS: "update-radius",
};

export default {
  name: "MonitorRadiusField",
  props: {
    monitorRadius: {
      type: [String, Number],
      required: true,
      default: "",
    },
    poisDistUnits: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      monitorRadiusRules: [this.validateMonitorRadius],
    };
  },
  computed: {
    unit() {
      return this.poisDistUnits === "miles" ? "mi" : "km";
    },
    displayMonitorRadius: {
      get() {
        return formatDisplayMonitorRadius(
          parseFloat(this.monitorRadius),
          this.poisDistUnits
        );
      },
      set(newVal) {
        const transformedValue = transformRadiusToKm(newVal, this.unit);
        if (this.monitorRadius !== transformedValue) {
          this.$emit(EMITTED_ACTIONS.UPDATE_RADIUS, transformedValue);
        }
      },
    },
    labelRadius() {
      return `Monitoring Radius (${this.unit})`;
    },
  },
  watch: {
    monitorRadius(newVal) {
      this.displayMonitorRadius = formatDisplayMonitorRadius(
        newVal,
        this.poisDistUnits
      );
    },
  },
  methods: {
    validateMonitorRadius(value) {
      if (!value) return true; // Bypass validation if no value
      const numValue = parseFloat(value);
      if (isNaN(numValue)) return "Invalid number.";
      const isValid = /^\d+(\.\d{0,1})?$/.test(value);
      if (!isValid) return "Max 1 decimal places.";
      if (numValue > 100) {
        return `Radius exceeds limit. (Min: 0.1${this.unit} - Max: 100${this.unit})`;
      }
      return true;
    },
  },
};
</script>
